import React from "react";
import Country from "../../Components/Tracking/Country";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const CountryPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <Country date={query.date} />
    </React.Fragment>
  );
};

export default CountryPage;
